export default __webpack_public_path__ + "static/media/arrow-left.27042d43.svg";